import React, { useEffect } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

// import required modules
import { Pagination } from 'swiper/modules';
import './StudentSuccess.css'

import s1 from './s1.jpg'
import s2 from './s2.jpg'
import s3 from './s3.jpg'
import s4 from './s4.jpg'
// import s5 from './s5.jpg'

function StudentSuccess() {
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        })
    }, [])
    return (
        <section className='studentsuccess-section'>
            <div className='container'>
                <div className='heading'>
                    <span>STUDENT SUCCESS STORIES</span>
                </div>
                <div className='success-detail'>
                    <Swiper
                        slidesPerView={3}
                        spaceBetween={30}
                        pagination={{
                            clickable: true,
                        }}
                        breakpoints={{
                            310:{
                                slidesPerView: 1,
                                spaceBetween: 10
                            },
                            640: {
                              slidesPerView: 2,
                              spaceBetween: 20,
                            },
                            768: {
                              slidesPerView: 2,
                              spaceBetween: 40,
                            },
                            1024: {
                              slidesPerView: 3,
                              spaceBetween: 50,
                            },
                          }}
                        modules={[Pagination]}
                        className="mySwiper-success"
                    >
                        <SwiperSlide className='image'><img src={s1} alt=''/></SwiperSlide>
                        <SwiperSlide className='image'><img src={s2} alt=''/></SwiperSlide>
                        <SwiperSlide className='image'><img src={s3} alt=''/></SwiperSlide>
                        <SwiperSlide className='image'><img src={s4} alt=''/></SwiperSlide>
                        {/* <SwiperSlide className='image'><img src={s5} alt=''/></SwiperSlide> */}
                        {/* <SwiperSlide className='image'><img src={s6} alt=''/></SwiperSlide>
                        <SwiperSlide className='image'><img src={s7} alt=''/></SwiperSlide> */}
                    </Swiper>
                </div>
            </div>
        </section>
    )
}

export default StudentSuccess